class KillRecord {
  constructor (actor, qty = 0) {
    this.actor = actor;
    this.playerQty = qty;
  }
}

export default KillRecord;